<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <v-btn text tile v-bind="attrs" v-on="on">
        {{ nomeEmpresaLogada }}
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-for="empresa in empresasUsuario"
        :key="empresa.epCodigo"
        @click="trocarEmpresa(empresa.epCodigo)"
      >
        <v-list-item-title>
          {{ empresa.nome }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      empresasUsuario: []
    };
  },

  computed: {
    nomeEmpresaLogada() {
      return this.$utils.buscaNomeEmpresa(this.$store);
    }
  },

  methods: {
    async trocarEmpresa(epCodigo) {
      const usuarioAtual = this.$store.getters.user;
      const { token, refreshToken, identificador } = usuarioAtual;

      if (!epCodigo) {
        this.$api.UI.ShowError('Erro', 'Empresa inválida');
        return;
      }

      if (epCodigo === usuarioAtual.empresaLogada) {
        this.$api.UI.ShowAlert('Aviso', 'Você já está logado nessa empresa');
        return;
      }

      try {
        const dadosToken = await this.$api.Autenticacao.RefreshBackOffice(
          { epCodigo, token: refreshToken },
          token
        );

        const usuarioAtualizado = await this.$utils.salvarSessaoAutenticada({
          api: this.$api,
          store: this.$store,
          dadosToken,
          identificador,
          empresaLogada: epCodigo
        });
        window.location.reload();

        if (!usuarioAtualizado) {
          this.$api.UI.ShowError('Erro', 'Não foi possível renovar a sessão');
          setTimeout(this.$store.dispatch('logout'), 3000);
          return;
        }
      } catch (error) {
        this.$api.UI.ShowError('Erro', 'Não foi possível trocar de empresa');
      }
    }
  },

  async beforeMount() {
    try {
      const usuario = this.$store.getters.user;
      const empresas = await this.$api.BackOffice.ListarBackOffice(
        usuario.token
      );
      this.empresasUsuario = empresas.map(({ epCodigo, nome }) => ({
        epCodigo,
        nome
      }));
    } catch (error) {
      this.$api.UI.ShowError(
        'Erro',
        'Não foi possível carregar as empresas disponíveis'
      );
    }
  }
};
</script>
